import { mapActions } from 'vuex'
import { sorts } from './partials/fields'

export default {
    template: '<router-view />',

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.setParams({
                sorter: sorts[0].value
            })
            vm.fetchStoreTags()
            vm.fetchUsers()
            vm.fetchRoles({
                no_paginate: true
            })
        })
    },

    beforeRouteLeave (to, from, next) {
        this.resetParams()
        next()
    },

    methods: {
        ...mapActions({
            fetchUsers: 'user/fetch',
            setParams: 'user/setParams',
            resetParams: 'user/resetParams',
            fetchRoles: 'role/fetch',
            fetchStoreTags: 'store/fetchTags'
        }),
    }
}